
    initCart();
    function initCart() {
        let cartIcon = document.querySelector('.header__actions--mob [data-cart-icon]');
        var cartName = document.querySelector('.header__actions [data-cart-name]');
        let cartNameText = document.querySelector('.header__actions [data-cart-name]').dataset.cartName;
        let popupBag = document.querySelector('#popup_bag');
        let btnsQ = popupBag.querySelectorAll('.product-bag button');
        let btnDelete = popupBag.querySelectorAll('[data-remove-item]');

        btnDelete.forEach((item)=>{
            item.addEventListener('click', ()=>{
                popupBag.classList.add('loading');
                updateCart(item.dataset.key, 0);
            })
        })

        btnsQ.forEach((item)=>{
            let itemInput = item.closest('.quantity-input').querySelector('input');
            item.addEventListener('click', ()=>{
                popupBag.classList.add('loading');
                console.log(itemInput.max, itemInput.value)

                updateCart(itemInput.dataset.key, itemInput.value);
            })
        })

        if(popupBag.querySelector('.complete-look_product-btn') !== null){
            popupBag.querySelector('.complete-look_product-btn').addEventListener('click', function (e){
                e.preventDefault();
                popupBag.classList.add('loading');
                let select = popupBag.querySelector('select');
                let id = select.options[select.selectedIndex].value;
                popupBag.querySelector('.complete-look .error-option').innerHTML = ``;
                if(id != 'blank'){
                    addToCart(id,1);
                }else{
                    console.log('select option!')
                    popupBag.querySelector('.complete-look .error-option').innerHTML = `<span>${window.product.chose_variant}</span>`;
                    document.querySelector('#popup_bag').classList.remove('loading');
                }
            })
        }

        fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
            return response.text();
        }).then((state) => {
            const cart = JSON.parse(state);
            if(cart.item_count > 0){
                cartName.innerHTML = cartName.dataset.cartName + ' (' + cart.item_count + ')';
                cartIcon.dataset.count = cart.item_count;
            }else{
                cartName.innerHTML = cartName.dataset.cartName;
                cartIcon.dataset.count = '';
            }
        }) .catch((e) => {
            console.error(e);
        });

        document.querySelector('#popup_bag').classList.remove('loading');
    }


    function addToCart(id,q) {
        let formData = {
            'items': [{
                'id': id,
                'quantity': q
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                renderCart();
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    function updateCart(key,q) {
        let data = {
            "id": key,
            "quantity": q
        }
        let urlUpdate = window.shopUrl + window.routes.cart_change_url + '.js';
        fetch(urlUpdate, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then((data) => {
                renderCart();
                if(data.item_count == 0){
                    document.querySelector('#popup_bag .popup__close').click();
                }
            })
            .catch(error => console.error('Error:', error));
}
    function updateCartIcon(cartIcon, cartName) {
        fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
            return response.text();
        }).then((state) => {
            const cart = JSON.parse(state);
            if(cart.item_count > 0){
                cartName.innerHTML = cartName.dataset.cartName + ' (' + cart.item_count + ')';
                cartIcon.dataset.count = cart.item_count;
            }else{
                cartName.innerHTML = cartName.dataset.cartName;
                cartIcon.dataset.count = '';
            }

        }) .catch((e) => {
            console.error(e);
        });
    }
    function renderCart() {
        fetch(window.shopUrl).then(function(response) {
            return response.text();
        }).then(function(responseText) {
            const doc = new DOMParser().parseFromString(responseText, 'text/html');
            console.log('doc', doc)
            let fetchCartPopup = doc.querySelector('#popup_bag .popup__body_inner');
            let cartPopup = document.querySelector('#popup_bag .popup__body_inner');

            if (fetchCartPopup && cartPopup) {
                cartPopup.innerHTML = fetchCartPopup.innerHTML;
            }

            initCart();
            initAppCart();
            document.querySelector('#popup_bag').classList.remove('loading');
        }).catch(function(err) {
            console.error('Something went wrong.', err);
        });
    }

    function initAppCart() {
    /* - - - - - - - - - - - - - -       popup     - - - - - - - - - - - - - - - */
    function openPopup(popupId) {
        var popup = document.getElementById(popupId);
        var popupUser = document.querySelectorAll(".popup");
        popupUser.forEach(function (popup) {
            popup.classList.remove("open")
        });
        if (popup.classList.contains("open")) {
            popup.classList.remove("open");
            document.querySelector("body").classList.remove("disable-scroll")
        } else {
            popup.classList.add("open");
            document.querySelector("body").classList.add("disable-scroll")
        }
    }

    var popupUser = document.querySelectorAll(".popup");
    var popupClose = document.querySelectorAll(".popup__close");
    if (popupClose) {
        popupClose.forEach(function (element) {
            element.addEventListener("click", function (event) {
                popupUser.forEach(function (popup) {
                    popup.classList.remove("open")
                });
                document.querySelector("body").classList.remove("disable-scroll")
            })
        })
    }/* - - - - - - - - - - - - - -       popup     - - - - - - - - - - - - - - - */

    $('select').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
    });
}




